import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div``;

const Cover = styled.div`
  position: relative;
  height: 250px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${({ url }) => `url(${url})`};
  &.noCover {
    height: 80px;
  }
  &:hover {
    .coverButtons {
      opacity: 1;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  font-size: 70px;
`;

const IconContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
  &.full-width {
    max-width: 90%;
  }
`;

const CoverLogo = styled.div`
  bottom: -40px;
  position: absolute;
  width: 100%;
  z-index: 2;
`;

const PageCover = ({ knowledge }) => {
  const { coverUrl, emoji, pageSettings } = knowledge || {};

  return (
    <Wrapper>
      <Cover className={!coverUrl ? 'noCover' : ''} url={coverUrl}>
        {emoji && (
          <CoverLogo>
            <IconContainer className={pageSettings?.fullWidth ? 'full-width' : ''}>
              <IconWrapper>{emoji}</IconWrapper>
            </IconContainer>
          </CoverLogo>
        )}
      </Cover>
    </Wrapper>
  );
};

export default PageCover;
